import React, { useState } from 'react';
import './Screenshots.css';
import screenshot1 from '../../assets/images/screenshot-1.jpg';
import screenshot2 from '../../assets/images/screenshot-2.jpg';
import screenshot3 from '../../assets/images/screenshot-3.jpg';
import screenshot4 from '../../assets/images/screenshot-4.jpg';

const Screenshots: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const screenshots = [
    {
      title: 'Feed',
      description: 'Stay updated with your friends lifestyle moments',
      color: '#FFEB3B',
      image: screenshot1
    },
    {
      title: 'Profile',
      description: 'Express yourself with a personalized profile',
      color: '#FFC107',
      image: screenshot2
    },
    {
      title: 'Chat',
      description: 'Connect through seamless messaging',
      color: '#FFD54F',
      image: screenshot3
    },
    {
      title: 'Settings',
      description: 'Customize your experience your way',
      color: '#FFECB3',
      image: screenshot4
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === screenshots.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? screenshots.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section className="screenshots-section">
      <div className="screenshots-container">
        <div className="screenshots-header">
          <h2 className="screenshots-heading">See Gelwel in Action</h2>
          <p className="screenshots-subheading">
            Experience the beautiful interface designed for the modern lifestyle
          </p>
        </div>

        <div className="screenshots-carousel">
          <button
            className="screenshots-arrow screenshots-arrow-left"
            onClick={prevSlide}
            aria-label="Previous screenshot"
          >
            ‹
          </button>

          <div className="screenshots-track">
            {screenshots.map((screenshot, index) => (
              <div
                key={index}
                className={`screenshots-slide ${
                  index === currentIndex ? 'screenshots-slide-active' : ''
                }`}
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`
                }}
              >
                <div
                  className="screenshots-phone"
                  style={{ backgroundColor: screenshot.color }}
                >
                  <div className="screenshots-phone-notch"></div>
                  <div className="screenshots-phone-content">
                    <h3 className="screenshots-phone-title">{screenshot.title}</h3>
                    <img
                      src={screenshot.image}
                      alt={`${screenshot.title} screen`}
                      className="screenshots-phone-image"
                    />
                  </div>
                </div>
                <p className="screenshots-description">{screenshot.description}</p>
              </div>
            ))}
          </div>

          <button
            className="screenshots-arrow screenshots-arrow-right"
            onClick={nextSlide}
            aria-label="Next screenshot"
          >
            ›
          </button>
        </div>

        <div className="screenshots-dots">
          {screenshots.map((_, index) => (
            <button
              key={index}
              className={`screenshots-dot ${
                index === currentIndex ? 'screenshots-dot-active' : ''
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
